import type { ReactNode } from 'react';

export const symbol_flag_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-452v342q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q200-97.25 200-110v-700q0-12.75 8.63-21.38Q217.25-840 230-840h563q8.32 0 14.74 3.89 6.43 3.89 10.21 10.11 3.78 6.22 4.92 13.61Q824-805 820-797l-71 151 71 151q4 8 2.87 15.39-1.14 7.39-4.92 13.61-3.78 6.22-10.21 10.11Q801.32-452 793-452H260Zm0-60h485l-51-108q-6-12.13-6-26t6-26l51-108H260v268Zm0 0v-268 268Z"
		/>
	</svg>
);
